import { BasketActions } from '@state/basket/basketActions';
import { fetchGuests, GuestsActions } from '@state/slices/guests/guestSlice';
import { DealFinderResultsActions } from '@state/slices/deal-finder-results/dealFinderResultsSlice';
import { RoutingActions } from '@state/slices/app';
import { closeModal, ModalType, showModal } from './modalSlice';
import { createListener } from '@state/store/createListener';

/* *************** *
 *   LISTENERS     *
 * *************** */
export const setupModalListeners = () => {
  createListener(
    [BasketActions.RECEIVE_ADD_TO_BASKET_FAILURE, BasketActions.RECEIVE_BASKET_FAILURE, fetchGuests.rejected],
    async (action, listenerApi) => {
      listenerApi.dispatch(showModal({ modalType: ModalType.BASKET_ERROR, modalData: { code: action.payload } }));
    }
  );

  createListener([GuestsActions.INVALID_SEAT_SELECTION], async (_action, listenerApi) => {
    listenerApi.dispatch(showModal({ modalType: ModalType.INVALID_SEAT_SELECTION }));
  });

  createListener([DealFinderResultsActions.TOKEN_EXPIRED], async (_action, listenerApi) => {
    listenerApi.dispatch(showModal({ modalType: ModalType.DEAL_FINDER_TOKEN_EXPIRED }));
  });

  createListener([RoutingActions.LOCATION_CHANGE], async (_action, listenerApi) => {
    const state: any = listenerApi.getState();
    const modalType = state.app.modal.modalType;
    const modalData = state.app.modal.modalData;
    if (modalType !== ModalType.NONE && !modalData.persist) {
      listenerApi.dispatch(closeModal());
    }
  });
};
